import { ListService } from '@abp/ng.core';
import { Component, Input, OnInit } from '@angular/core';

import { AssetService } from '@/proxy/register-service/assets/asset.service';
import type { AssetDetailsDto } from '@/proxy/register-service/assets/models';
import { ColumnPreferenceService } from '../services/column-preference.service';
import { defaultAssetPreferences } from '@/shared/constants';

@Component({
  selector: 'app-sub-assets',
  templateUrl: './sub-assets.component.html',
  styleUrls: ['./sub-assets.component.scss'],
})
export class SubAssetsComponent implements OnInit {
  @Input() asset: AssetDetailsDto;

  assetColumns = defaultAssetPreferences.columns;
  isBusy = false;
  selected: AssetDetailsDto[] = [];

  constructor(public readonly list: ListService, public readonly service: AssetService, private readonly columnPreferenceService: ColumnPreferenceService) {}

  ngOnInit() {
    this.list.page = 0;

    this.columnPreferenceService
      .loadPreferences()
      .then(() => {
        const preferences = this.columnPreferenceService.getCurrentPreferences();
        if (preferences) {
          this.assetColumns = preferences.columns;
        }
      })
      .catch(() => {
        const fallbackPreferences = this.columnPreferenceService.getCurrentPreferences();
        if (fallbackPreferences) {
          this.assetColumns = fallbackPreferences.columns;
        }
      });
  }
}
